import { put, select, takeLatest } from 'redux-saga/effects'
import { CustomSignaturesConstants } from '../store/customSignature.constants'
import { getCustomSignaturesSelector } from '../selectors/getCustomSignature.selectors'
import { ICustomFormsSignatureState } from '../store/customSignature.types'
import {
  resetCustomSignatureClientData,
  saveCustomSignatureToPcr,
  saveCustomSignatures,
  savePrFormsCustom,
  setCounter,
} from '../store/customSignature.actions'
import { getCurrentDateTimeHH24FormatByTimeZone } from '../../../utilities/dateTime.util'
import { ConfigurationsConstants } from '../../configurations/store/configurations.constants'
import Logger from '../../../services/logger.service'
export function* addCustomSignature() {
  try {
    const customSignature: ICustomFormsSignatureState = yield select(getCustomSignaturesSelector)
    const { customSignatureClientData, prFormsSignature, prFormsCustom } = customSignature
    const { prFormsSignatureObj, counter } = customSignatureClientData

    const index = prFormsCustom.findIndex(
      (item) => item.formId === prFormsSignatureObj.formId && item.dt === prFormsSignatureObj.dt
    )

    const isFormPresent = prFormsCustom.filter((item) => item.formId === prFormsSignatureObj.formId)
    const currentDate = getCurrentDateTimeHH24FormatByTimeZone(ConfigurationsConstants.DEFAULT_TIMEZONE)

    if (index === -1) {
      let cnt

      if (isFormPresent.length > 0) {
        cnt = isFormPresent[0].seq
      } else {
        cnt = counter + 1
        yield put(setCounter(cnt))
      }

      yield put(saveCustomSignatures([...prFormsSignature, { ...prFormsSignatureObj, seq: cnt, dt: currentDate }]))
      yield put(
        savePrFormsCustom([
          ...prFormsCustom,
          {
            formId: prFormsSignatureObj.formId,
            seq: cnt,
            dt: currentDate,
          },
        ])
      )
    } else {
      prFormsSignature[index] = { ...prFormsSignatureObj, dt: currentDate }
      yield put(saveCustomSignatures(prFormsSignature))
      prFormsCustom[index].dt = currentDate
      yield put(savePrFormsCustom(prFormsCustom))
    }
    yield put(resetCustomSignatureClientData())
    yield put(saveCustomSignatureToPcr())
  } catch (e) {
    Logger.error(`addCustomSignature() error: ${e}`)
  }
}

export function* addCustomSignatureSaga() {
  yield takeLatest([CustomSignaturesConstants.ADD_CUSTOM_SIGNATURE], addCustomSignature)
}
